export const BROWSER_API_ERRORS_INTEGRATION_NAME = 'BrowserApiErrors';

export const IGNORED_ERROR_SNIPPETS = [
  'Error invoking enableDidUserTypeOnKeyboardLogging: Java object is gone',
  'enableDidUserTypeOnKeyboardLogging',
  'Java object is gone',
  'objectStoreNames',
  'createObjectStore',
  'QuotaExceededError',
];

export const IGNORED_EXCEPTION_TYPES = new Set(['NotAllowedError']);

export const STALE_BUILD_MESSAGES = [
  '\'text/html\' is not a valid JavaScript MIME type',
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'error loading dynamically imported module',
  'Unable to preload CSS',
  'Loading chunk',
  'Loading CSS chunk',
];

export const NETWORK_FAILURE_NAMES = new Set(['AbortError', 'TimeoutError']);

export const NETWORK_FAILURE_MESSAGES = [
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource',
  'Network Error',
];

export const MAX_CAUSE_DEPTH = 5;

export const NON_PRODUCTION_ENVIRONMENTS = new Set(['development', 'test']);

export const PLACEHOLDER_FRAME_FILENAMES = new Set(['<anonymous>', '[native code]']);

export const APP_REPORT_TAG = { name: 'reported_by', value: 'app' } as const;

export const POLICY_TAG_NAME = 'sentry_policy';

export const QUERY_PARAM_PATTERN = /([?&])([^&#]*)/g;

export const SENSITIVE_KEY_PATTERN = /email|phone/i;

export const SENSITIVE_KEY_NAMES = new Set([
  's',
  'age',
  'addgoal',
  'add_goal',
  'maingoal',
  'main_goal',
  'secondarygoal',
  'secondary_goal',
  'uuid',
  'useruuid',
  'user_uuid',
  'webuseruuid',
  'web_user_uuid',
]);

export const MASKED_VALUE = '[Filtered]';

export const URL_FIELD_NAMES = new Set(['from', 'to', 'url', 'path', 'Referer']);

export const MAX_MASK_DEPTH = 3;

export const MAX_PENDING_ERRORS = 20;

export const MAX_PENDING_NOTES = 80;

export const MAX_SENTRY_LOAD_ATTEMPTS = 3;
